import { UserManager } from "oidc-client";
import { createUserManager } from "redux-oidc";
import { OidcConfigurationResponseModel } from "../models/OidcConfigurationResponseModel";

let userManager: UserManager;

// Maps the Business Portal language (en, nl, fr, de) to the ui_locales value expected by Identity.
const uiLocalesByLanguage: Record<string, string> = {
    en: "en-gb",
    nl: "nl-nl",
    fr: "fr-fr",
    de: "de-de",
};

export const getUiLocales = (language: string): string => {
    const key = (language || "").split("-")[0].toLowerCase();
    return uiLocalesByLanguage[key] ?? "en-gb";
};

const getUserManager = function (oidcConfig: OidcConfigurationResponseModel) {
    if (userManager) {
        return userManager;
    }

    const currentHostName = `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ""}`;

    const userManagerConfig = {
        authority: oidcConfig.serverUrl,
        client_id: oidcConfig.clientId,
        client_secret: oidcConfig.clientSecret,
        redirect_uri: `${currentHostName}/signin-oidc`,
        response_type: "code",
        scope: "openid profile IdentityServerApi offline_access",
        monitorSession: false,
        loadUserInfo: false,
        post_logout_redirect_uri: currentHostName,
        automaticSilentRenew: true,
        accessTokenExpiringNotificationTime: 60 // 60 seconds before expiration
    };

    userManager = createUserManager(userManagerConfig);

    return userManager;
};

export default getUserManager;
